/*
 *
 * NewTreatmentUserStep constants
 *
 */

export const DEFAULT_ACTION = "app/NewTreatmentUserStep/DEFAULT_ACTION";
